import moment from 'moment'

export const datePrimaryFormat = dt => {
  if (dt) {
    return moment(dt).calendar(null, {
      sameDay: 'HH:mm [Uhr]',
      nextDay: '[Morgen] HH:mm [Uhr]',
      nextWeek: 'DD.MM.YYYY HH:mm [Uhr]',
      lastDay: '[Gestern] HH:mm [Uhr]',
      lastWeek: 'DD.MM.YYYY HH:mm [Uhr]',
      sameElse: 'DD.MM.YYYY HH:mm [Uhr]'
    })
  }
  return ''
}

export const dateTimeFromNow = dt => {
  if (dt) {
    const dtm = moment(dt)
    const diff = moment().subtract(1, 'hours')
    if (dtm.isAfter(diff)) {
      return dtm.fromNow()
    }
    return datePrimaryFormat(dt)
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/util/datetime.js